const weather = [
    '晴', '多云', '阴',
    '阵雨', '雷阵雨', '雷阵雨伴有冰雹', '雨夹雪', '小雨', '中雨', '大雨', '暴雨', '大暴雨', '特大暴雨',
    '阵雪', '小雪', '中雪', '大雪', '暴雪',
    '雾', '冻雨', '沙尘暴',
    '小到中雨', '中到大雨', '大到暴雨', '暴雨到大暴雨', '大暴雨到特大暴雨',
    '小到中雪', '中到大雪', '大到暴雪',
    '浮尘', '扬沙', '强沙尘暴', '霾', '无']
const formatWeather = (val: number) => {
    if (val === 53) {
        return '霾'
    } else {
        return weather[val]
    }
}
const formatSkyConIcon = (val: number) => {
    if (val < 10) {
        return `d0${val}`
    }
    return `d${val}`
}
export default {
    formatWeather, formatSkyConIcon,
}
